async function createLoan(answers, setCurrentLoan) {
  const targetUrl = `${process.env.CMS_URL}/loans`;

  const savedAnswers = answers.map((answer) => {
    return {
      a_string: answer["a_string"],
      q_id: answer["q_id"],
      q_title: answer["a_title"],
    };
  });

  const newLoanResp = await fetch(targetUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //make sure to serialize your JSON body
    body: JSON.stringify({
      Answers: savedAnswers,
    }),
  });

  const newLoan = await newLoanResp.json();

  setCurrentLoan(newLoan);

  return newLoan;
}

export default createLoan;
